<pdq-card variant="popover" color="white">
  <div class="container">
    <div class="header">
      <pdq-heading element="h3" capitalized="true">Connect to {{ data.integrationDisplayName }}</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="content">
      <pdq-input
        [label]="data.fieldLabel"
        [placeholder]="data.placeholder ?? ''"
        [(ngModel)]="value"
        [disabled]="submitting"
        [invalid]="!!errorMessage"
        [invalidMsg]="errorMessage"
        [autofocus]="true"
        (onEnter)="submit()"></pdq-input>
      <p class="hint body-12-regular">{{ data.helperText }}</p>
    </div>
    <pdq-divider></pdq-divider>
    <footer>
      <pdq-button variant="tertiary" label="Cancel" [disabled]="submitting" (onClick)="cancel()"></pdq-button>
      <pdq-button
        variant="primary"
        label="Validate and Connect"
        [loading]="submitting"
        [disabled]="!value || submitting"
        (onClick)="submit()"></pdq-button>
    </footer>
  </div>
</pdq-card>
